import { bookBadgeOf, typeInfo } from "../../../../constants/typeInfo";

// 모르는 종류가 와도 화면이 깨지지 않게 기본값을 둔다
const FALLBACK_TYPE_INFO = { text: "과제", color: "#5B6670", backgroundColor: "#F1F3F5" };

const TypeBox = ({ type, isMobile, title }) => {
  const info = typeInfo[type] || FALLBACK_TYPE_INFO;
  const badge = bookBadgeOf(type, title);
  return (
    <div
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: 800,
        padding: isMobile ? "4px 14px" : "6px 18px",
        color: info.color,
        backgroundColor: info.backgroundColor,
        borderRadius: "999px",
        whiteSpace: "nowrap",
        letterSpacing: "-0.01em",
        ...(badge ? badge.style : {}),
      }}
    >
      {badge ? badge.text : info.text}
    </div>
  );
};

export default TypeBox;
